// extracted by mini-css-extract-plugin
export default {"LastProducts":"styles_LastProducts__9i-Q8"};